import * as React from "react";
import { SelectInput } from "~/components/Controls/Select";
import style from "./index.module.scss";

interface IPaginatorProps {
  padding: number;
  offset: number;
  limit: number;
  total: number;
  onChange: (page: number, perPage: number) => void;
  limits?: number[]; // default is: 10, 25, 50
}

const defaultLimits: number[] = [10, 25, 50];

export function Pagination(props: IPaginatorProps) {
  let { limit, offset, total, padding, limits = defaultLimits } = props;

  if (total < limit) {
    return null;
  }

  let pages = Math.ceil(total / limit);
  let page = Math.floor(offset / limit);

  let firstPage = page > padding ? page - padding : 0;
  let lastPage = pages - page > padding ? page + padding : pages - 1;

  let onChangeLimit = (newLimit: number) => {
    let newPages = Math.ceil(total / newLimit);
    if (page > newPages - 1) {
      props.onChange(Math.floor(offset / newLimit), newLimit);
    } else {
      props.onChange(page, newLimit);
    }
  };

  let onChangePage = (newPage: number) => {
    if (page !== newPage) {
      props.onChange(newPage, props.limit);
    }
  };

  let pageButtons = [];
  for (let num = firstPage; num <= lastPage; num++) {
    pageButtons.push(
      <button
        key={`page-${num}`}
        type="button"
        className={[
          style["page-button"],
          num === page ? style["page-button-active"] : "",
        ].join(" ")}
        onClick={() => onChangePage(num)}
      >
        {num + 1}
      </button>
    );
  }

  return (
    <div className={style.pagination}>
      {firstPage > 0 && [
        <button
          key="first-page"
          type="button"
          className={`${style["page-button"]} ${style["page-button-icon-only"]}`}
          onClick={() => onChangePage(0)}
        >
          <i className="fas fa-angle-double-left" aria-hidden="true" />
        </button>,
        <button
          key="prev-page"
          type="button"
          className={`${style["page-button"]} ${style["page-button-icon-only"]}`}
          onClick={() => onChangePage(page - 1)}
        >
          <i className="fas fa-angle-left" aria-hidden="true" />
        </button>,
      ]}
      {pageButtons}
      {lastPage < pages - 1 && [
        <button
          key="next-page"
          type="button"
          className={`${style["page-button"]} ${style["page-button-icon-only"]}`}
          onClick={() => onChangePage(page + 1)}
        >
          <i className="fas fa-angle-right" aria-hidden="true" />
        </button>,
        <button
          key="last-page"
          type="button"
          className={`${style["page-button"]} ${style["page-button-icon-only"]}`}
          onClick={() => onChangePage(pages - 1)}
        >
          <i className="fas fa-angle-double-right" aria-hidden="true" />
        </button>,
      ]}
      <div className={style["per-page"]}>
        <span className={style["per-page-label"]}>Per page:</span>
        <SelectInput
          key="changeLimit"
          value={limit}
          items={(limits || defaultLimits).map((newLimit) => ({ label: newLimit.toString(), value: newLimit }))}
          onChange={(value) => onChangeLimit(value)}
          dropUp
          className={style["per-page-select"]}
        />
      </div>
    </div>
  );
}
